"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isValidPrepTypeToTrain = exports.SalesforceTrainingErrors = exports.PrepDataSourceStatus = exports.GetDomainErrors = exports.AddCleanStepErrors = exports.PrepPublishErrors = exports.DomainRetrievalStatus = exports.PrepDataType = exports.PredictionType = exports.ObjectiveSubspaceStatus = exports.ModelStatus = exports.isRegressionModel = exports.isBinomialModel = exports.ModelType = exports.Algorithm = exports.Goal = exports.TrainingPhase = exports.SubspaceType = exports.OutcomeType = exports.REDUX_STATUS = void 0;
var REDUX_STATUS;
(function (REDUX_STATUS) {
    REDUX_STATUS["idle"] = "idle";
    REDUX_STATUS["loading"] = "loading";
    REDUX_STATUS["succeeded"] = "succeeded";
    REDUX_STATUS["failed"] = "failed";
})(REDUX_STATUS = exports.REDUX_STATUS || (exports.REDUX_STATUS = {}));
var OutcomeType;
(function (OutcomeType) {
    OutcomeType["Number"] = "Number";
    OutcomeType["Text"] = "Text";
    OutcomeType["Undefined"] = "undefined";
})(OutcomeType = exports.OutcomeType || (exports.OutcomeType = {}));
/** Numeric field represent the header index */
var SubspaceType;
(function (SubspaceType) {
    SubspaceType[SubspaceType["Connect"] = 0] = "Connect";
    SubspaceType[SubspaceType["Define"] = 1] = "Define";
    SubspaceType[SubspaceType["Train"] = 2] = "Train";
    SubspaceType[SubspaceType["Results"] = 3] = "Results";
    SubspaceType[SubspaceType["Deploy"] = 4] = "Deploy";
})(SubspaceType = exports.SubspaceType || (exports.SubspaceType = {}));
var TrainingPhase;
(function (TrainingPhase) {
    TrainingPhase[TrainingPhase["Undefined"] = 0] = "Undefined";
    TrainingPhase[TrainingPhase["Processing"] = 1] = "Processing";
    TrainingPhase[TrainingPhase["DataMovement"] = 2] = "DataMovement";
    TrainingPhase[TrainingPhase["DescriptiveAnalysis"] = 3] = "DescriptiveAnalysis";
    TrainingPhase[TrainingPhase["ModelCreation"] = 4] = "ModelCreation";
    TrainingPhase[TrainingPhase["Complete"] = 5] = "Complete";
})(TrainingPhase = exports.TrainingPhase || (exports.TrainingPhase = {}));
var Goal;
(function (Goal) {
    Goal["Maximize"] = "Maximize";
    Goal["Minimize"] = "Minimize";
})(Goal = exports.Goal || (exports.Goal = {}));
var Algorithm;
(function (Algorithm) {
    Algorithm["GLM"] = "GLM";
    Algorithm["GBM"] = "GBM";
    Algorithm["XGBoost"] = "XGBOOST";
    Algorithm["RandomForest"] = "DRF";
    Algorithm["Model_Tournament"] = "BEST";
})(Algorithm = exports.Algorithm || (exports.Algorithm = {}));
var ModelType;
(function (ModelType) {
    ModelType["Undefined"] = "Undefined";
    ModelType["Binomial"] = "Binomial";
    ModelType["BinomialGLM"] = "BinomialGLM";
    ModelType["Regression"] = "Regression";
    ModelType["RegressionGLM"] = "RegressionGLM";
})(ModelType = exports.ModelType || (exports.ModelType = {}));
var isBinomialModel = function (type) { return type === ModelType.Binomial || type === ModelType.BinomialGLM; };
exports.isBinomialModel = isBinomialModel;
var isRegressionModel = function (type) { return type === ModelType.Regression || type === ModelType.RegressionGLM; };
exports.isRegressionModel = isRegressionModel;
// TODO Remove once we sync with VPC
/** @deprecated */
var ModelStatus;
(function (ModelStatus) {
    ModelStatus[ModelStatus["Undefined"] = 0] = "Undefined";
    ModelStatus[ModelStatus["ObjectiveDefined"] = 1] = "ObjectiveDefined";
    ModelStatus[ModelStatus["Training"] = 2] = "Training";
    ModelStatus[ModelStatus["Trained"] = 3] = "Trained";
    ModelStatus[ModelStatus["Deployed"] = 4] = "Deployed";
})(ModelStatus = exports.ModelStatus || (exports.ModelStatus = {}));
var ObjectiveSubspaceStatus;
(function (ObjectiveSubspaceStatus) {
    ObjectiveSubspaceStatus[ObjectiveSubspaceStatus["Enabled"] = 1] = "Enabled";
    ObjectiveSubspaceStatus[ObjectiveSubspaceStatus["Disabled"] = 2] = "Disabled";
})(ObjectiveSubspaceStatus = exports.ObjectiveSubspaceStatus || (exports.ObjectiveSubspaceStatus = {}));
var PredictionType;
(function (PredictionType) {
    PredictionType["Regression"] = "numeric";
    PredictionType["Binary"] = "binary";
    PredictionType["Undefined"] = "undefined";
})(PredictionType = exports.PredictionType || (exports.PredictionType = {}));
var PrepDataType;
(function (PrepDataType) {
    PrepDataType["Integer"] = "integer";
    PrepDataType["String"] = "string";
    PrepDataType["Real"] = "real";
    PrepDataType["Spatial"] = "spatial";
    PrepDataType["Date"] = "date";
    PrepDataType["DateTime"] = "datetime";
    PrepDataType["Boolean"] = "boolean";
})(PrepDataType = exports.PrepDataType || (exports.PrepDataType = {}));
var DomainRetrievalStatus;
(function (DomainRetrievalStatus) {
    DomainRetrievalStatus[DomainRetrievalStatus["Retrieving"] = 0] = "Retrieving";
    DomainRetrievalStatus[DomainRetrievalStatus["Retrieved"] = 1] = "Retrieved";
    DomainRetrievalStatus[DomainRetrievalStatus["Error"] = 2] = "Error";
    DomainRetrievalStatus[DomainRetrievalStatus["Unknown"] = 3] = "Unknown";
})(DomainRetrievalStatus = exports.DomainRetrievalStatus || (exports.DomainRetrievalStatus = {}));
var PrepPublishErrors;
(function (PrepPublishErrors) {
    PrepPublishErrors["UnpublishedFlow"] = "UNPUBLISHED_FLOW";
    PrepPublishErrors["PermissionDenied"] = "PERMISSION_DENIED";
    PrepPublishErrors["OverwriteWithoutFlag"] = "OVERWRITE_WITHOUT_FLAG";
    PrepPublishErrors["Unknown"] = "UNKNOWN";
})(PrepPublishErrors = exports.PrepPublishErrors || (exports.PrepPublishErrors = {}));
var AddCleanStepErrors;
(function (AddCleanStepErrors) {
    AddCleanStepErrors["invalidStepType"] = "INVALID_STEP_TYPE";
    AddCleanStepErrors["originStepNotFound"] = "ORIGIN_STEP_NOT_FOUND";
    AddCleanStepErrors["unknown"] = "UNKNOWN";
})(AddCleanStepErrors = exports.AddCleanStepErrors || (exports.AddCleanStepErrors = {}));
var GetDomainErrors;
(function (GetDomainErrors) {
    GetDomainErrors["StepNotFound"] = "STEP_NOT_FOUND";
    GetDomainErrors["ColumnNotFound"] = "COLUMN_NOT_FOUND";
    GetDomainErrors["RunFailed"] = "RUN_FAILED";
    GetDomainErrors["Unknown"] = "UNKNOWN";
})(GetDomainErrors = exports.GetDomainErrors || (exports.GetDomainErrors = {}));
var PrepDataSourceStatus;
(function (PrepDataSourceStatus) {
    PrepDataSourceStatus["connectionError"] = "CONNECTION_ERROR";
    PrepDataSourceStatus["flowNotPublished"] = "FLOW_NOT_PUBLISHED";
    PrepDataSourceStatus["columnsNotReceived"] = "COLUMNS_NOT_RECEIVED";
    PrepDataSourceStatus["columnSizeError"] = "COLUMN_SIZE_ERROR";
    PrepDataSourceStatus["none"] = "NONE";
})(PrepDataSourceStatus = exports.PrepDataSourceStatus || (exports.PrepDataSourceStatus = {}));
var SalesforceTrainingErrors;
(function (SalesforceTrainingErrors) {
    SalesforceTrainingErrors["concurrentLimitExceeded"] = "CONCURRENT_LIMIT_EXCEEDED";
})(SalesforceTrainingErrors = exports.SalesforceTrainingErrors || (exports.SalesforceTrainingErrors = {}));
var isValidPrepTypeToTrain = function (type) {
    return (type && (type === PrepDataType.Integer || type === PrepDataType.Real || type === PrepDataType.String || type === PrepDataType.Boolean));
};
exports.isValidPrepTypeToTrain = isValidPrepTypeToTrain;
//# sourceMappingURL=Utils.js.map